import { MediaType } from "../../../types";
import { ImageAsset } from "./image";


export class Image360Asset extends ImageAsset {
  getMediaType() {
    return MediaType.Image360;
  }

  async getDownloadUrl(useCache = true): Promise<string> {
    const baseUrl = await this.getFileUrl(useCache);
    return this.addPathToFileUrl(new URL(baseUrl), 'img.hq').toString();
  }
}